module.exports = __webpack_public_path__ + "4b36aaa8578d7858fd166b60b5b3c885.ttf";